import { keyframes } from '@emotion/react';
import { KmxCheckStroked } from '@kmx/mui-icons';
import Box from '@mui/material/Box';
import Grow from '@mui/material/Grow';
import { styled, useTheme } from '@mui/material/styles';
import { type MouseEventHandler, useCallback } from 'react';

import type { CompareConfig } from '@/types/CompareConfig';

import StyledMenuButton from './StyledMenuButton';

const myAnimation = keyframes`
  0% {
  }

  50% {
    opacity: 1;
  }
  99% {
    transform: scale(1.4);
    opacity: 0;
  }
  100% {
    transform: scale(1);
  }
`;

const CompareButtonRing = styled(Box)(({ theme }) => ({
  position: 'absolute',
  height: 40,
  width: 40,
  top: '-20px',
  right: '8px',
  opacity: 0,
  borderRadius: '50%',
  boxSizing: 'border-box',
  border: '1px solid',
  borderColor: theme.palette.primary.main,
  background: 'transparent',
  animationDelay: '0.2s',
  animationIterationCount: 1,
  animationFillMode: 'forwards',
  animation: `${myAnimation} 1s ease-in-out`,
  zIndex: 1,
}));

type CompareButtonProps = {
  isSelected: boolean;
  onClick: CompareConfig['onClick'];
};

const CompareButton = ({ isSelected, onClick }: CompareButtonProps) => {
  const theme = useTheme();

  const isSelectedStyling = {
    backgroundColor: theme.palette.primary.light,
    color: 'white',
  };

  const handleClick: MouseEventHandler<HTMLButtonElement> = useCallback(
    (event) => {
      event.preventDefault();
      onClick(!isSelected);
    },
    [isSelected, onClick],
  );

  const buttonAriaLabel = isSelected ? 'Remove from Compare' : 'Add to Compare';
  const buttonStyling = isSelected ? isSelectedStyling : undefined;

  return (
    <>
      <CompareButtonRing className="kmx-car-tile__compare-button-ring" />

      <Grow in={true} timeout={800}>
        <StyledMenuButton
          size="large"
          onClick={handleClick}
          style={buttonStyling}
          aria-label={buttonAriaLabel}
          className="kmx-car-tile__compare-button"
          data-selected={isSelected}
        >
          <KmxCheckStroked />
        </StyledMenuButton>
      </Grow>
    </>
  );
};

export default CompareButton;
